// extracted by mini-css-extract-plugin
export default {"container":"MenuGroupModal--container--126ee1","description":"MenuGroupModal--description--7d5c8b","descLabel":"MenuGroupModal--descLabel--b4177a"};